import axios from 'axios';

export class GaleriaServices {
    getValuesServiceSerie(servicoImagem, studyUid) {
        let seriesAslDicom = [];
        
        return axios.get(`${servicoImagem}/${studyUid}/getstudyimagens`)
            .then(res => {
                res.data.instanceImage.forEach(obj => {
                    seriesAslDicom.push({
                        Serie: obj.serie,
                        Instances: obj.instances
                    });
                });
                return seriesAslDicom;
            })
            .catch(error => {
                console.log(error);
                return [];
            });
    }
}